import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { Observable, map, switchMap } from 'rxjs'

import { ManifestResourceType } from '@flowx/designer/shared/entities/manifest-resource-type.entity'

import { ResourceHistoryApiService } from '../api/resource-history.api.service'
import { ApplicationVersion } from '../entities/application.entity'
import { selectAllRouteParams } from '../store/selectors/router.selectors'

export type ResourceHistory = (ApplicationVersion & { resourceId: string; resourceName: string })[]
export type ResourceHistoryParams = {
  resourceDefinitionId: string
  resourceType: ManifestResourceType
  resourceName: string
}

@Injectable({ providedIn: 'root' })
export class ResourceHistoryService {
  #resourceHistoryApi = inject(ResourceHistoryApiService)
  #ngrxStore = inject(Store)

  getResourceHistory(query: ResourceHistoryParams): Observable<ResourceHistory> {
    return this.#ngrxStore.select(selectAllRouteParams).pipe(
      map((urlParams) => ({
        appId: urlParams.appId,
        appVersionId: urlParams.appVersionId,
      })),
      switchMap(({ appId, appVersionId }) =>
        this.#resourceHistoryApi
          .getResourceHistory(appId, appVersionId, query.resourceDefinitionId)
          .pipe(
            map((resourceHistory) =>
              resourceHistory.map((version) => ({
                ...version.applicationVersion,
                resourceId: version.resourceId,
                resourceName: version.resourceName,
              }))
            )
          )
      )
    )
  }
}
